import {Component, OnInit} from '@angular/core';
import { Model, StylesManager} from 'survey-angular';
import {TranslateService} from "@ngx-translate/core";
import { jwtDecode } from "jwt-decode";
import {AuthenticationService} from "./services/authentication.service";


StylesManager.applyTheme('modern');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css', ]
})
export class AppComponent implements OnInit{
  constructor( private translateService: TranslateService, private authenticationService: AuthenticationService)
  {
    this.translateService.setDefaultLang('de')
    this.translateService.use(localStorage.getItem('lang') || 'de');
  }

  model: Model;

  ngOnInit() {
    if (!this.authenticationService.isAdmin.value) {
      let isJwtAdmin = false;
      try {
        const token = localStorage.getItem('access_token') || '';
        isJwtAdmin = !!(token && jwtDecode(token)?.['role'] === 'admin');
      } catch {
        // opaque token or invalid JWT — not a backend admin token
      }

      const isLogtoAdmin = localStorage.getItem('login_provider') === 'logto';

      if (isJwtAdmin || isLogtoAdmin) {
        this.authenticationService.isAdmin.next(true);
      }

      if (isLogtoAdmin) {
        // Logto session restored on reload — re-fetch live roles (superadmin flag).
        this.authenticationService.refreshCurrentRoles();
      } else if (isJwtAdmin) {
        // Legacy admin restored on reload — treat as full admin.
        this.authenticationService.applyLegacyFullAdmin();
      }
    }
  }
}
